import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=1f2dba10&scoped=true"
import script from "./ImageInput.vue?vue&type=script&lang=js"
export * from "./ImageInput.vue?vue&type=script&lang=js"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=1f2dba10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2dba10",
  null
  
)

export default component.exports